import React, { useEffect, useState } from 'react';
import { getCountryName, getLocationByIP, getMyIP } from '../services/locationService';

const headerStyle: React.CSSProperties = {
  marginBottom: '20px',
  fontWeight: 'bold',
  fontSize: '30px',
  textAlign: 'center',
};

const FreeIPLocation: React.FC = () => {
  const [ip, setIp] = useState<string>('');
  const [locationInfo, setLocationInfo] = useState<any>(null);
  const [error, setError] = useState<string>('');
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // ✅ Trạng thái gửi form

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setLoading(true);
        const ipData = await getMyIP();
        setIp(ipData.ip);
        const locationData = await getLocationByIP(ipData.ip);
        setLocationInfo(locationData);
      } catch (err) {
        setError('Error fetching initial data');
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  const handleCopy = () => {
    if (!loading && locationInfo) {
      navigator.clipboard.writeText(locationInfo.ip);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const validateIp = (value: string): boolean => {
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
    return ipRegex.test(value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (ip.trim() === '') {
      setError('IP address is required');
      return;
    } else if (!validateIp(ip)) {
      setError('Invalid IP address format');
      return;
    } else {
      setError('');
    }

    // ✅ Chặn submit nhiều lần nếu đang gửi request
    if (isSubmitting) return;
    
    setIsSubmitting(true); // Đặt trạng thái gửi form

    try {
      setLoading(true);
      const data = await getLocationByIP(ip);
      setLocationInfo(data);
    } catch (err) {
      setError('Error fetching location info');
    } finally {
      setLoading(false);
      setIsSubmitting(false); // Reset trạng thái sau khi gửi xong
    }
  };

  return (
    <div className="card p-3">
      <header style={headerStyle}>Instantly Locate Any IP Address</header>

      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            className="form-control"
            type="text"
            placeholder="Enter IP Address"
            value={ip}
            onChange={(e) => setIp(e.target.value)}
            // Không disable input, chỉ kiểm tra trên nút submit
          />
          <button
            className="btn btn-primary"
            type="submit"
            style={{ padding: '10px 20px' }} 
          >
            Get Location
          </button>
        </div>
      </form>

      {/* Loading Spinner */}
      {loading && (
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {/* Error message */}
      {error && (
        <div className="alert alert-danger mt-3" role="alert">
          {error}
        </div>
      )}

      {!loading && locationInfo && (
        <div className="row mt-3">
          <div className="col-lg-6">
            <table className="table">
              <tbody>
                <tr>
                  <td>
                    <strong>Your IP address</strong>
                  </td>
                  <td>
                    {locationInfo.ip}{' '}
                    <span
                      style={{
                        fontStyle: 'italic',
                        color: '#007bff',
                        cursor: 'pointer',
                        width: 80,
                        float: 'right',
                      }}
                      onClick={handleCopy}
                    >
                      {!copied ? '(copy)' : <span style={{ color: 'green' }}>✓ Copied!</span>}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Latitude</strong>
                  </td>
                  <td>{locationInfo.coords.latitude}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Longitude</strong>
                  </td>
                  <td>{locationInfo.coords.longitude}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Country</strong>
                  </td>
                  <td>{getCountryName(locationInfo.country)}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Region</strong>
                  </td>
                  <td>{locationInfo.region}</td>
                </tr>
                <tr>
                  <td>
                    <strong>City</strong>
                  </td>
                  <td>{locationInfo.city}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Organization</strong>
                  </td>
                  <td>{locationInfo.organisation}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {locationInfo.coords && (
            <div className="col-lg-6">
              <iframe
                width="100%"
                height="400"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                src={`https://www.google.com/maps?q=${locationInfo.coords.latitude},${locationInfo.coords.longitude}&hl=es;z=14&output=embed`}
              ></iframe>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FreeIPLocation;
